import { State } from 'src/types'
import { indexFingerCover } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/indexFinger'
import {
  indexFingerPad,
  indexFingerPadOfFType,
  indexFingerPadWithNoEdge
} from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/indexFingerPad'

export const fingerGuardDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  switch (state.fingerGuardType.value) {
    case 'indexPadWithNoEdge':
      // ヘリ無し指当て
      indexFingerPadWithNoEdge(ctx, state.indexCover.color, state.stitch.color)
      break
    case 'indexCover':
      // 指カバー
      indexFingerCover(ctx, state.indexCover.color, state.stitch.color)
      break
    case 'indexPad':
      // 指当て
      indexPadSwitcher(ctx, state)
      break
  }
}

const indexPadSwitcher = (ctx: CanvasRenderingContext2D, state: State): void => {
  switch (state.baseModel.brand) {
    default:
      // atoms, gorilla
      indexFingerPad(ctx, state.indexCover.color, state.stitch.color)
      break
  }
}
